<div class="nav-container">
  <div class="nav-content">
    @if (menuChecked) {
      <mat-nav-list>
        @for (item of menuItems; track item.route) {
          <app-nav-item [menu]="item" [index]="$index" [parentMenu]="null" [parentMenuIsOpen]="false"></app-nav-item>
        }
      </mat-nav-list>
    } @else {
      <cg-loading />
    }
  </div>
</div>
